// USA
export const locale = {
  TRANSLATOR: {
    SELECT: "Select your language"
  },
  AUTH: {
    TIPS: {
      MESSAGE: "Prompt message",
      REFRESH: "Please refresh and retry.",
      REPEAT: "The email address already exists.",
      REGISTERTWO:"Account registered!",
      SUCCESS: "Operation succeeded,please log in.",
      INEXISTENCE: "This account does not exist, please register",
      FAIL: "The account or password is incorrect.",
      CONFIMPASS: "Confirm the password must be the same as the password",
      CONSENTCLAUSE: "Please agree to the registration terms",
    },
    ICLOUD: {
      NAME_TOP: "PCB Online quotation order",
      NAME_FOOT: "platform"
    },
    GENERAL: {
      WELCOME: "Welcome to LEADCLOUD",
      SUBMIT_BUTTON: "Sign In",
      INQUIRY_BUTTON: "inquiry",
      NO_ACCOUNT: "Don't have an account?",
      SIGNUP_BUTTON: "Sign Up",
      FORGOT_BUTTON: "Forgot Password",
      PRIVACY: "Privacy",
      LEGAL: "Legal",
      CONTACT: "Contact"
    },
    INPUT: {
      EMAIL: "Email",
      PASSWORD: "Password",
      FULLNAME: "Fullname",
      COMPANY: "corporation",
      CONFIRM_PASSWORD: "Confirm Password",
      ADDRESS: "address",
      LINKMAN: "linkman",
    },
    VALIDATION: {
      EMAIL: "Email is required and a valid email address.",
      PASSWORD: "Password is required.",
      FULLNAME: "Fullname is required",
      COMPANY: "corporation is required",
      ADDRESS: "address is required",
      LINKMAN: "linkman is required",
      CONFIMPASS: "Confirm Password is required",
    },
    FORGOT: {
      TITLE: "Forgot Password?",
      DESC: "Enter your email to reset your password",
      SUCCESS: "Your account has been successfully reset.",
      SUBMIT_BUTTON: "Submit",
      CANCEL_BUTTON: "Cancel",
      CONFIRM_BUTTON: "Confirm",
    },
    REGISTER: {
      TITLE: "Sign Up",
      DESC: "Enter your details to create your account",
      SUCCESS: "Your account has been successfuly registered.",
      SUBMIT_BUTTON: "Submit",
      CANCEL_BUTTON: "Cancel",
      CONDITION_TOP: "I Agree the",
      CONDITION_FOOT: "terms and conditions.",
    },
  },
  MENU: {
    NEW: "new",
    ACTIONS: "Actions",
    CREATE_POST: "Create New Post",
    PAGES: "Pages",
    FEATURES: "Features",
    APPS: "Apps",
    DASHBOARD: "Dashboard"
  },
  ECOMMERCE: {
    COMMON: {
      SELECTED_RECORDS_COUNT: "Selected records count: ",
      ALL: "All",
      SUSPENDED: "Suspended",
      ACTIVE: "Active",
      FILTER: "Filter",
      BY_STATUS: "by Status",
      BY_TYPE: "by Type",
      BUSINESS: "Business",
      INDIVIDUAL: "Individual",
      SEARCH: "Search",
      IN_ALL_FIELDS: "in all fields"
    },
    ECOMMERCE: "eCommerce",
    CUSTOMERS: {
      CUSTOMERS: "Customers",
      CUSTOMERS_LIST: "Customers list",
      NEW_CUSTOMER: "New Customer",
      DELETE_CUSTOMER_SIMPLE: {
        TITLE: "Customer Delete",
        DESCRIPTION: "Are you sure to permanently delete this customer?",
        WAIT_DESCRIPTION: "Customer is deleting...",
        MESSAGE: "Customer has been deleted"
      },
      DELETE_CUSTOMER_MULTY: {
        TITLE: "Customers Delete",
        DESCRIPTION: "Are you sure to permanently delete selected customers?",
        WAIT_DESCRIPTION: "Customers are deleting...",
        MESSAGE: "Selected customers have been deleted"
      },
      UPDATE_STATUS: {
        TITLE: "Status has been updated for selected customers",
        MESSAGE: "Selected customers status have successfully been updated"
      },
      EDIT: {
        UPDATE_MESSAGE: "Customer has been updated",
        ADD_MESSAGE: "Customer has been created"
      }
    }
  },
  CONTENT:{
    REDMSG: "Please enter the red asterisk required option",
    System_Management:"System Management",
    MAKE_OFFERS:"Place an order",
    MY_INFORNATIONAL:"My information",
    TO_BE_CONFIRM: "unConfirmed",
    To_Be_Audit:"unAudit",
    CONFIRM:"confirm",
    See_More:"See more",
    To_Be_Payment:"Pending payment",
    Payment:"payment",
    Order_Management:"Order management",
    Edit:"edit",
    Delete:"delete",
    View:"view",
    Audit:"audit",
    Pay_Comfirm:"Pay Comfirm",
    Withdraw:"withdraw",
    SELECT_ORDER_TYPE:"Please select the order type",
    Sample_Prompt:"The sample area cannot be larger than 0.1㎡",
    SELECT_ITEM_VALUE:"The content cannot be empty！",
    PnlLength:"Specifications Dimension length cannot be empty！",
    PnlWidth:"Specifications Dimension width cannot be empty！",
    Quantity:"The quantity cannot be empty！",
    Brand:"The brand cannot be empty！",
    Product:"Please configure the product！",
    Repulse:"repulse",
    No_content_was_matched:"No content was matched!",
    No_attachment_selected:"No attachment selected. Do you want to continue placing the order"
  },
  USER:{
    User_Profile:"User Profile",
    Logout:"Logout",
    Home_Page:"Home page",
    Avatar:"Avatar"
  },
  BOTTOM:{
    About:"ABOUT",
    TEAM:"TEAM",
    Contact:"CONTRACT",
    LEADCLOUD:"LEADCLOUD",
    Contact_Platform:"Contact"
  },
  ACCOUNT:{
    Account_Information:"Account Information",
    Save_Changes:"Save Changes",
    Cancel:"Cancel",
    Account:"Account",
    Fullname:"Fullname",
    Email:"Email",
    corporation:"Corporation",
    Address:"Address",
    Linkman:"Linkman",
    Language:"Language",
    Select_Language:"Select Language",
    English:"English",
    Simplified_Chinese:"Simplified Chinese",
    Weekly_Income:"Cumulative order amount",
    Sales_Change:"Cumulative order area",
    Change_your_account_settings:"Change your account settings",
    gender:"gender",
    phone:"phone",
    industry:"industry",
    webUrl:"webUrl",
    Upload_pictures:"Upload attachments",
  },
  PRICE:{
    PRODUCT:"product",
    CRAFT_ORDER:"technological parameter",
    Order:"Immediate valuation",
    OrderTwo:"Order",
    Automobile_lighting:"Automobile lighting",
    Outdoor_lighting:"Outdoor lighting",
    Plant_lighting:"Plant lighting",
    Plate_type:"Plate type",
    Number_Board_layers:"Number Board layers",
    Board_Size:"Board size",
    The_number_of_pieces:"Number pieces",
    quantity:"quantity",
    Shipping_method:"Shipping method",
    Board_thickness:"Board thickness",
    Solder_resistance_color:"Solder resistance color",
    Character_color:"Character color",
    Exposure_screen_printing:"Exposure screen printing",
    Outer_copper_thickness:"Outer copper thickness",
    Pad_spray_plating:"Pad spray plating",
    Line_test:"Line test",
    Forming_method:"Forming method",
    Area:"Area",
    Number_boards:"Number_boards",
    Heat_conduction:"Heat conduction",
    Withstand_voltage:"Withstand voltage",
    Special_technology:"Special technology",
    Special_requirements:"Special requirements",
    Select_material_brand:"Select material brand",
    Specification_parameter:"Specification_parameter",
    Select_express:"Select express",
    Order_date:"Order date",
    Estimated_delivery:"Estimated delivery",
    Estimated_price:"Estimated price",
    Order_delivery_date:"Order delivery date",
    Total_amount:"Total amount",
    Exchange_rate:"Exchange rate",
    Order_agreement:"Order agreement",
    Material_fee_and_other_background_confirmation:"Material fee and other background confirmation"
  },
  PRICECONENT:{
    Drup:"Drup",
    Nobutaka:"Nobutaka",
    Shengyi:"Shengyi",
    Aluminium_base:"Aluminium base",
    Single_side:"Single side",
    two_sided:"Two-sided",
    Exposure:"Exposure",
    Screen_printing:"Screen_printing",
    Antioxidant:"Antioxidant",
    Gild:"Gild",
    Spray_lead_free_tin:"Spray lead-free tin",
    Sprayed_with_lead_tin:"Sprayed with lead tin",
    Heavy_gold:"Heavy gold",
    Copper_rosin:"Copper rosin",
    Silvering:"Silvering",
    Manual_visual_inspection:"Manual visual inspection",
    Computer_test:"Computer test",
    Flying_needle_test:"Flying needle test",
    New_test_rack:"New test rack",
    Rack_test:"Rack test",
    Scan:"Scan",
    Jointed_board:"Jointed board",
    Finished_product:"Finished product",
    Price:"Price",
    Freight:"Freight",
    Express_delivery:"Express delivery",
    ageing:"ageing",
    stamping:"stamping",
    computer:"computer",
    CNC_v_threading:"CNC V-threading",
    Reinforced_packing:"Reinforced packing",
    Withstand_voltage_measurement:"Withstand voltage measurement",
    stripping:"stripping",
    superpore:"superpore",
    Crosses_are_not_accepted:"Crosses are not accepted",
    Erasure_is_not_accepted:"Erasure is not accepted",
    Dot_copper_leakage_is_not_accepted:"Dot copper leakage is not accepted",
    Do_not_accept_the_Philin_seal:"Do not accept the Philin seal",
    Do_not_accept_the_fork_wipe_copper_leakage:"Do not accept the fork wipe copper leakage",
    Single_piece_data_single_piece_shipment:"Single piece data single piece shipment",
    Shipment_according_to_customer_information:"Shipment according to customer information",
    Lead_the_virtue_to_fight:"Lead the virtue to fight",
    Sf_Express:"Sf Express",
    flexible:"flexible",
    Sto_Express:"Sto Express",
  },
  COLOR:{
    Green:"green",
    High_anti_white_oil:"High anti white oil",
    Black:"black",
    Blue:"blue",
    Yellow:"yellow",
    Red:"red",
    Purple:"purple",
    White:"white",
    Without:"without",
  },
  ORDER:{
    My_order:"My order",
    inquire:"inquire",
    derive:"derive",
    confirm:"confirm",
    Order_Information:"Order Information",
    Price:"Price",
    Order_Attachment:"Order Attachment",
    Order_progress:"Order progress",
    Controls:"Controls",
    LEADCLOUD:"LEADCLOUD",
    Product_technology:"Product technology",
    Order_status:"Order status",
    Information_Manage:"Information Manage",
    Confirm_The_Order:"Confirm The Order",
    Sales_Order:"Are you sure you want to confirm the order?",
    Delete_Order:"Delete Order",
    Cancel_Order:"Are you sure you want to delete the order?",
    Audit_The_Order:"Audit The Order",
    Audit_Order:"Are you sure you want to review your order?",
    Pay_Confirm_The_Order:"Pay Confirm The Order",
    Pay_Sales_Order:"Are you sure you want to confirm the payment order？",
    Upload_file:"Attachment Management",
    File_list:"File list",
    Order_back:"Order back",
    Make_sure_to_return_the_order:"Make sure to return the order？"
  },
  ONLINE:{
    Product_Type:"Product Type",
    SIZE:"Size",
    LENGTH:"Length",
    WIDTH:"Width",
    Specification_Size:"Specification",
    Concatenation_Number:"Number",
    QUANTITY:"Quantity",
    Order_Type:"Order Type",
    New_Order:"New Order",
    REORDER:"Reorder",
    Currency_Type:"Currency Type",
    Process_Validation:"Process Validation",
    Quotation_details:"Quotation details",
    RMB:"RMB",
    PICTURE:"Picture",
    DOCUMENT:"document",
    Large_Text:"Large Text",
    Customer_Name:"Customer Name",
    specification:"Specification",
    area:"Area",
    amount:"Amount",
    Order_Time:"Order Time",
    Order_Delivery_Time:"Order Delivery Time",
    status:"Status",
    Order_Progress:"Order Progress",
    Controls:"Controls",
    To_be_confirmed:"unConfirmed",
    Pending_Approval:"Pending approval",
    due:"Pending payment",
    In_Production:"In Production",
    unconfirmed:"unConfirmed",
    Order_Number:"Order Number",
    Offline_Transfer:"Offline Transfer",
    file:"File",
    upload:"Attachment Management",
    View_upload:"View_upload",
    delete:"Delete",
    confirm:"Confirm",
    Cancel:"Cancel",
    attachments:"Attachments",
    Download:"Download",
    Preview:"Preview",
    Please_Select_An_Order:"Please Select An Order",
    Do_Not_Click_More_Than_Once:"Do Not Click More Than Once",
    Hit_Back:"Hit Back",
    Confirm_Success:"Confirm Success",
    Successful_Audit:"Successful Audit",
    Payment_Confirmation_Successful:"Payment Confirmation Successful",
    Please_refresh_and_retry:"Please refresh and retry",
    Successfully_deleted:"Successfully deleted",
    Save_successfully:"Save successfully",
    Already_exist:"Already exist",
    Upload_only:"Upload only",
    File_name_extension:"File name extension",
    System_error:"System error",
    Please_select_a_currency_type:"Please select a currency type",
    Reset_password_successfully:"Reset password successfully",
    Failed_to_reset_password:"Failed to reset password",
    Please_enter_email:"Please enter email",
    male:"Male",
    female:"Female",
    Please_log_in:"Please log in",
    Upload_successfully:"Upload successfully",
    Upload_failed_please_refresh_and_try_again:"Upload failed please refresh and try again",
    The_file_name_has_been_uploaded:"The file name has been uploaded",
    Attachment_management:"upload",
    Upload_attachment:"Upload attachment",
    Please_enter_a_number_that_cannot_be_less_than_zero:"Please enter a number that cannot be less than zero!",
    DATA_FILES:"Data files",
    Computer_upload:"Computer upload",
    Upload_attachments:"Upload attachments"
  },

  CRAFTVALUE:{
    NickName:"nickname",
    ContactEmail:"Contact email",
    MobilePhone:"Mobile phone number",
    COUNTRY:"country",
    Annual_demand:"Annual demand",
    Profession:"Product application",
    Quote_immediately:"Quote immediately",
    Add_quoted_items_by_material_process:"Add quoted items by material process",
    Augment:"augment",
    Quotation_list:"Quotation list",
    Unit_price_per_square_meter:"Unit price per square meter",
    Delete:"delete",
    Quoted_item:"Quoted item",
    Close:"close",
    Verify:"verify",
    Item_type:"Item type",
    Item_selection:"Item selection",
    PCB_type:"PCB type",
    Copper_clad_sheet:"Copper-clad sheet",
    Sheet_thickness:"Sheet thickness",
    Copper_coating_requirement:"Copper coating requirement",
    Coating_treatment:"Coating treatment",
    Solder_resistance_type:"Solder resistance type",
    Panel_character:"Panel character",
    Forming_method:"Forming method",
    Test_requirement:"Test requirement",
    Yuan:"RMB",
    Personal_information:"Personal information",
    You_have_registered_successfully_account:"You have registered successfully account",
    Password:"Password",
    You_can_go_to_the_top_left_page_to_specify_an_order:"You can go to the top left page to specify an order",
    Amount:"Amount",
    Area:"Area",
    Download:"Download",
  },
  QUOTATION:{
    Offer:"Offer",
    Material_classification:"Material classification",
    Process_classification:"Process classification",
    Process_information:"Process information",
    Bid_successful:"Bid successful!",
    Unit:"Unit",
    CustomerName:"Customer Name",
    View_quote_history:"quote history",
    No_permission_to_view_quotation_records:"No permission to view quotation records",
    Quotation_record:"Quotation record",
    Click_on_the_blue_price_below_to_modify_it:"Click on the blue price below to modify it"
  }
};
